if (!customElements.get('company-timeline')) {
  customElements.define('company-timeline', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-milestone]')];
      this.panels = [...this.querySelectorAll('.about-timeline__panel')];
      this.addEventListener('pointerover', event => {
        const button = event.target.closest('[data-milestone]');
        if (button && button !== this.active && event.pointerType !== 'touch') { this.pinned = null; this.show(button); }
      }, options);
      this.addEventListener('focusin', event => {
        const button = event.target.closest('[data-milestone]');
        if (button) this.show(button);
      }, options);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-milestone]');
        if (!button) return;
        if (this.pinned === button) { this.pinned = null; this.show(null); }
        else { this.pinned = button; this.show(button); }
      }, options);
      this.addEventListener('pointerleave', () => {
        if (!this.pinned && !this.contains(document.activeElement)) this.show(null);
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget) && !this.pinned) this.show(null);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.pinned = null; this.show(null); }
        const button = event.target.closest('[data-milestone]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = this.buttons.indexOf(button);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : Math.max(0, Math.min(this.buttons.length - 1, index + window.TytoDirection.arrow(event.key, this)));
        this.buttons[next].focus({ preventScroll: true });
        this.buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
    }
    show(button) {
      this.active = button;
      this.buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
      const id = button?.getAttribute('aria-controls');
      this.panels.forEach(panel => { panel.hidden = panel.id !== id; });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
